const digest = '88d5f2b1610ecdb2f22acd98bc6cc5a0c522f748fe692aed073b1299b5f6563b';
const css = `div[id=survey-dialog-box]>div[role=dialog]{border-radius:5px;padding:.875rem!important;width:90%}._surveyPopUpButton_182u3_7{width:48%}@media screen and (max-width:370px){._surveyPopUpButtonContainer_182u3_12{flex-direction:column-reverse}._surveyPopUpButton_182u3_7{margin-bottom:.5rem;width:100%}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'surveyPopUpButton': '_surveyPopUpButton_182u3_7', 'surveyPopUpButtonContainer': '_surveyPopUpButtonContainer_182u3_12' };
export const surveyPopUpButton = '_surveyPopUpButton_182u3_7';
export const surveyPopUpButtonContainer = '_surveyPopUpButtonContainer_182u3_12';
export { css, digest };